export function emergencyBanner() {
    const banner = document.querySelector('.emergency-banner');
    const modal = document.querySelector('.emergency-banner__modal');
    const marquee = document.querySelector('.emergency-banner__marquee');
    const dismissButton = document.querySelector('.emergency-banner__button-close');
    const learnMoreButton = document.querySelector('.emergency-banner__marquee .wp-block-button__link');
    
    function setCookie(name, value, days) {
        const expires = new Date(Date.now() + days * 864e5).toUTCString();
        document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/';
    }

    function getCookie(name) {
        return document.cookie.split('; ').reduce((r, v) => {
            const parts = v.split('=');
            return parts[0] === name ? decodeURIComponent(parts[1]) : r
        }, '');
    }

    function showElement(el) {
        el.style.display = 'flex';
        requestAnimationFrame(() => {
            el.classList.add('emergency-banner--visible');
        });
    }

    function hideElement(el, callback) {
        el.classList.remove('emergency-banner--visible');
        
        const onTransitionEnd = (e) => {
            if (e.propertyName === 'opacity') { // Make sure it's opacity transition
                el.removeEventListener('transitionend', onTransitionEnd);
                // Wait a small moment to ensure smoothness
                setTimeout(() => {
                    el.style.display = 'none';
                    if (typeof callback === 'function') {
                        callback();
                    }
                }, 50); // 50ms feels natural
            }
        };
        el.addEventListener('transitionend', onTransitionEnd);
    }

    if (!getCookie('emergencyBannerDismissed')) {
        banner.classList.remove('emergency-banner__dismissed');
        showElement(modal);
    } else {
        banner.classList.add('emergency-banner__dismissed');
        showElement(marquee);
    }

    dismissButton.addEventListener('click', function(e) {
        e.preventDefault();
        setCookie('emergencyBannerDismissed', 'true', 7);
        hideElement(modal, function() {
            banner.classList.add('emergency-banner__dismissed');
            showElement(marquee);
        });
    });

    learnMoreButton.addEventListener('click', function(e) {
        e.preventDefault();
        hideElement(marquee, function() {
            banner.classList.remove('emergency-banner__dismissed');
            showElement(modal);
        });
    });

    modal.addEventListener('click', function(e) {
        if (e.target === modal) {
            hideElement(modal, function() {
                showElement(marquee);
            });
        }
    });
}